<!--
 * @Description:
 * @Version:
 * @Autor: houchuanfang
 * @Date: 2022-08-02 17:23:59
 * @LastEditTime: 2023-03-07 14:52:31
-->
<template>
  <div class="organ-list">
    <div class="breadcrumb mainWidth">
      <span class="name">当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>残疾人职业中介服务机构</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="select">
      <div class="search">
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" class="search_input" v-model="page.deptName">
        </el-input>
        <el-button type="primary" class="btn" @click="goSearch">搜索</el-button>
      </div>
      <div class="input flex">
        <div class="label">地区筛选：</div>
        <selectCategory aria-label="下拉列表框" ref="city" style="width:240px;" :changeonselect="true" class="selects"
                        codeType="provinceid" dictValue="p05" placeholder="请选择市区" expandTrigger="hover"
                        :codeLevel="3" @change="getCity"></selectCategory>
      </div>
    </div>
    <ul class="flex tabs mainWidth">
      <li v-for="(tab, index) in tabs" :key="tab.ord" @click="changeTab(tab, index)"
          :class="[params.ord == tab.ord && 'active']">{{ tab.name }}
      </li>
    </ul>
    <template v-if="params.ord == 1">
      <div class="lists flex flex-wrap mainWidth" v-loading="loading">
        <div v-for="item in hrCompanyList" :key="item.id">
          <router-link :to="'/job/businessDetails?companyId='+ item.id" target="_blank">
            <img :src="item.logo" class="logo err_logo" style="background-size: 100% 100%"
                 alt="">
            <div>
              <h3>
                {{ item.companyName }}
              </h3>
              <div>
                <p><img src="@/static/hebei/index/posi.png"
                        alt=""><span><span>{{ item.provinceid || '' }}{{ item.cityid || '' }}{{
                    item.threeCityid || ''
                  }}</span></span>
                </p>
              </div>
              <div class="nums flex" style="justify-content: space-between;"><span>招聘职位<i>{{ item.jobCount }}</i>个</span><span>{{
                  item.updateTime.split(' ')[0]
                }}</span>
              </div>
            </div>
          </router-link>
        </div>
        <status v-if="!loading && hrCompanyList.length < 1" type="record" des="暂无数据"></status>
      </div>
    </template>

    <!-- 爱心企业 -->
    <div class="lists1 flex flex-wrap mainWidth" v-loading="loading">
      <template v-if="params.ord == 0">
        <div class="lists  lists2 flex flex-wrap mainWidth">
          <div v-for="item in organList">
            <router-link :to="'/training/mechanismDetail?id='+item.deptId" target="_blank">
              <img
                  :src="item.deptImg ?item.deptImg:'https://imgcdpee.cdpee.org.cn/c0084172f8ee45e2b2cf75d65afb0292.jpg'"
                  alt="">
              <div>
                <h3>{{ item.deptName }}</h3>
                <div class="desc">
                  <p>
                    <label>联系人</label>：<span>{{ item.leader }}</span>
                  </p>
                  <p>
                    <label>联系电话</label>：<span>{{ item.phone }}</span>
                  </p>
                  <p>
                    <label>机构地址</label>：<span>{{ item.address }}</span>
                  </p>
                </div>
              </div>
            </router-link>
          </div>
          <status v-if="!loading && organList.length < 1" type="record" des="暂无数据"></status>
        </div>
        <!-- <div class="company" v-for="item in list1" :key="item.id">
          <router-link :to="'/news/newDetail?id='+item.id" target="_blank">
            <img :src="item.thumbnail" alt="">
            <div>
              <p class="title line_clamp1">{{item.title}}</p >
              <span class="yearsT line_clamp2">{{item.conAbstract}}</span>
            </div>
          </router-link>
        </div> -->
      </template>
    </div>
    <!-- <div class="pagination flexs" v-if="params.ord == ''"> -->
    <el-pagination v-if="params.total" background :total="params.total" @size-change="handleSizeChangeone"
                   @current-change="handleCurrentChange" :current-page.sync="params.pageNum"
                   :page-size="params.pageSize" layout="prev, pager, next, total, jumper"></el-pagination>
    <!-- </div> -->
    <!-- <div class="pagination flexs" v-if="params.ord == 1">
      <el-pagination v-if="page.total" background :total="page.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page.pageNum"
        :page-size="page.pageSize" layout="prev, pager, next, total, jumper"></el-pagination>
    </div> -->
  </div>
</template>
<script>
import selectCategory from '@/components/selectComponents/selectCategory'

export default {
  components: {selectCategory},
  data() {
    return {
      list1: [],
      page: {
        pageNum: 1,
        pageSize: 25,
        total: 0,
        city: '',
        leve: '',
        deptName: '',
        cityId: '',
        threeCityid: '',
        consultationClassId: '233a24ae17a48fc2cf74d5ae58de6e2e'
      },
      hrCompanyList: [],
      tabs: [
        {
          name: '各级残联就业服务机构',
          ord: 0
        },
        {
          name: '社会人力资源服务机构',
          ord: '1'
        }
        // {
        //   name: '爱心企业',
        //   ord: 1,
        // },
      ],
      params: {
        pageNum: 1,
        pageSize: 20,
        addrProvince: '',
        addrCity: '',
        total: 0,
        ord: ''
      },
      organList: [],
      loading: true
    };
  },
  methods: {
    //获取选中地区
    getCity(val) {
      console.log(val)
      this.page.cityid = val[0];
      this.page.threeCityid = val[1];
      console.log(this.page.cityid)
      this.goSearch();
    },
    handleCurrentChange(val) {
      this.params.pageNum = val;
      if (this.params.ord == 0) {
        this.getOrgan();
      } else {
        this.hrCompany();
      }
    },
    handleSizeChangeone() {
      this.params.pageNum = val;
    },
    handleSizeChange() {
      this.page.pageNum = val;
    },
    changeTab(tab, index) {
      this.params.ord = tab.ord;
      this.reset();
      if (index == 0) {
        this.getOrgan();
      } else {
        this.hrCompany();
      }
      if (this.$route.query.tab) {
        this.$router.replace({
          path: '/organ'
        });
      }
    },
    getOrgan() {
      this.loading = true;
      console.log(this.page.cityId,this.page.threeCityid)
      this.$api
          .getDeptApi({
            deptName: this.page.deptName,
            cityid: this.page.cityid,
            threeCityid:this.page.threeCityid,
            pageSize: this.params.pageSize,
            pageNum: this.params.pageNum
          })
          .then(res => {
            res = res.data;
            if (res.success) {
              this.loading = false;
              this.organList = res.data?.records ?? [];
              this.params.total = res.data.total;

            }
          });
    },
    // 爱心企业
    newsL() {
      this.$api
          .newsListApi({
            pageNum: 1,
            pageSize: 15,
            companyName: this.page.deptName,
            city: this.page.city,
            leve: this.page.leve,
            consultationClassId: this.page.consultationClassId
          })
          .then(res => {
            this.loading = false;
            if (res.data.success) {
              this.list1 = res.data.data.records;
              this.page.total = res.data.data.total;
            }
          })
          .catch(err => {
            this.loading = false;
          });
    },
    // 社会机构展示
    hrCompany() {
      this.loading = true;
      this.$api
          .hrCompany({
            companyName: this.page.deptName,
            cityid: this.page.cityid,
            threeCityid:this.page.threeCityid,
            pageNum: this.params.pageNum,
            pageSize: this.params.pageSize
          })
          .then(res => {
            res = res.data;
            if (res.success) {
              this.hrCompanyList = res.data?.records ?? [];
              this.params.total = res.data.total;
              this.loading = false;
            }
          });
    },
    reset() {
      this.params.pageNum = 1;
      this.page.deptName = '';
      this.page.cityId = ''
      this.page.threeCityid = '';
      this.$refs.city.value = []
    },
    goSearch() {
      if (this.params.ord == 0) {
        this.getOrgan();
      } else {
        this.hrCompany();
      }
    }
  },
  mounted() {
    let tab = this.$route.query.tab;
    if (tab) {
      this.params.ord = tab;
      tab == 0 ? this.getOrgan() : this.hrCompany();
    } else {
      this.getOrgan();
    }
  }
};
</script>

<style lang='less' scoped>
.organ-list {
  padding-bottom: 48px;

  .mainWidth {
    width: 1200px;
    margin: 0 auto;
  }

  .breadcrumb {
    margin: 36px auto;
  }

  .pagination {
    margin-bottom: 36px;
  }

  ul.tabs {
    height: 59px;
    align-items: center;
    background: #ffffff;
    border: 1px solid rgba(0, 18, 10, 0.05);
    margin-bottom: 36px;
    padding: 0 18px;

    li {
      margin-right: 48px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #66716c;
      line-height: 59px;
      cursor: pointer;
      box-sizing: border-box;
      position: relative;

      &.active {
        color: #00120a;

        &::before {
          position: absolute;
          display: block;
          content: '';
          width: 100%;
          height: 3px;
          background-color: #28a46d;
          bottom: 1px;
        }
      }
    }
  }

  .lists2 {
    & > div {
      padding: 17px 12px !important;
    }

    h3 {
      margin-top: -5px;
      font-size: 16px;
      color: #00120a;
      line-height: 24px !important;
    }

    .desc {
      p {
        margin-bottom: 0 !important;

        label {
          display: inline-block;
          width: 58px;
          text-align: justify;
          text-align-last: justify;
        }

        span,
        label {
          font-size: 14px;
          color: #66716c !important;
          line-height: 20px !important;
          margin-bottom: 0px;
        }
      }
    }
  }

  .lists {
    & > div:not(.status) {
      background: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0.05);
      margin-bottom: 18px;
      padding: 18px;
      width: calc(50% - 9px);

      &:not(:nth-of-type(2n)) {
        margin-right: 18px;
      }

      a {
        display: flex;

        & > img {
          width: 120px;
          height: 90px;
          background-color: #f6f6f6;
        }

        & > div {
          flex: 1;
          padding-left: 12px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          h3 {
            font-weight: 500;
          }

          .nums {
            i {
              color: #28a46d;
              font-style: normal;
              margin: 0 4px;
            }
          }

          p {
            margin-bottom: 4px;

            img,
            span {
              vertical-align: middle;
            }

            span {
              color: #28a46d;
            }
          }

          span {
            color: #66716c;
            line-height: 22px;
          }
        }
      }
    }
  }

  .company {
    display: flex;
    width: 384px;
    // width: calc(33% - 24px);
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
    padding: 12px;

    &:not(:nth-of-type(3n)) {
      margin-right: 24px;
    }

    a {
      display: flex;
      width: 100%;

      &:hover {
        .title {
          color: #28a46d;
        }
      }

      & > img {
        width: 114px;
        height: 84px;
      }

      & > div {
        margin-left: 12px;
        line-height: 24px;
        font-size: 16px;

        .yearsT {
          margin-top: 12px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #66716c;
          line-height: 22px;
        }

        .title {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: #00120a;
          line-height: 24px;
        }
      }
    }
  }

  /deep/ .pagination {
    .btn-prev,
    .el-pager li,
    .btn-next,
    .el-input__inner {
      background: rgba(0, 18, 10, 0.05);
    }

    .el-pagination__editor.el-input {
      width: 48px;
      height: 25px;
    }
  }
}

.select {
  display: flex;
  align-items: center;
  width: 1200px;
  margin: 16px auto;

  .input {
    align-items: center;
    margin-left: 24px;

    .label {
      font-size: 16px;
    }
  }

  //background: white;

}
</style>
